<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h2 class="Verse-head" id="_idParaDest-13"><a id="_idTextAnchor013"></a>Cracked Pot</h2>
<p class="Verse-new">Earthen vessel</p>
<p class="Verse-main">cracked and broken</p>
<p class="Verse-main">leaky, dry</p>
<p class="Verse-main">good for nothing</p>
<p class="Verse-main">but to die.</p>
<p class="Verse-new">Now with glue</p>
<p class="Verse-main">and patient skill</p>
<p class="Verse-main">re-shaped: blue-green-grey</p>
<p class="Verse-main">beautiful and <em class="italic _idGenCharOverride-1">capax dei </em>– </p>
<p class="Verse-main">cracks alight with holy fire</p>
<p class="Verse-main">flaming in the dark spaces</p>
<p class="Verse-main">of my breaking heart. </p>
<p class="Verse-new">Hammered into shape</p>
<p class="Verse-main">on the anvil of that love,</p>
<p class="Verse-main">she turns towards</p>
<p class="Verse-main">the light, vessel of mercy,</p>
<p class="Verse-main">fountain for the thirsty</p>
<p class="Verse-main">haven from the howling</p>
<p class="Verse-main">stiffening cold. </p>
<p class="Verse-new">It was a happy day</p>
<p class="Verse-last">a blackbird pecking worms</p>
<p class="Verse-last">a chaffinch in the little tree</p>
<p class="Verse-last">a liberated cockroach </p>
<p class="Verse-last">scrambles out the garden door</p>
<p class="Verse-last">welcomed to the safety</p>
<p class="Verse-last">of the singing springing </p>
<p class="Verse-last">scrubby grass. </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398400801_EPUB-15.vue?7728019c